import { Heading } from "@planningcenter/doxy-web"
import { Link } from "react-router-dom"

export default function PaymentMethods() {
  return (
    <section>
      <div className="d-f fd-c ta-c g-2 p-4">
        <div className="d-f jc-c">
          <img src="/static/moved-payment-methods.svg" alt="" />
        </div>
        <Heading
          level={1}
          size={3}
          color="tint3"
          text="Payment methods have moved to your profile settings!"
        />
        <p className="c-tint3 ta-c mx-a" style={{ maxWidth: 350 }}>
          Now you can use your saved payment methods for any payments in Church
          Center.
        </p>
        <div>
          <Link className="btn btn-primary" to="/me/profile/payment-methods">
            Go to my payment methods
          </Link>
        </div>
      </div>
    </section>
  )
}
